export default "dist/images/block-feature-plain.659c41d.png";